import { defineEffect } from '../../../core/effect';

/**
 * **カードの確認**（Issue #538）。相手に見せた・自分が覗いたカード。
 *
 * 開く: `confirm_cards`。見せたカードを**枚数ぶん**画面の下に並べる（`for`）。
 */
const COLOR = '#c8d0e0';

export default defineEffect({
  situation: 'confirm_cards',
  label: 'カードの確認',
  color: COLOR,

  opens({ payload }) {
    return payload?.cards?.length ? payload : null;
  },

  layers: [
    {
      id: 'card',
      label: '見せたカード',
      part: 'card',
      for: 'cards',
      at: { screen: [960, 760] },
      props: { code: '{code}', player: '{player}', glow: COLOR, glowW: 4 },
      tf: {
        // **並べるのは `index` ぶんの平行移動**（`for` が `{index}` を渡す）
        x: { keys: [{ ms: 0, value: 0 }] },
        scale: { keys: [{ ms: 0, value: 0.3 }, { ms: 260, value: 0.5, ease: 'ease_out' }, { ms: 1000, value: 0.5 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 200, value: 1 }, { ms: 900, value: 1 }, { ms: 1100, value: 0 }] },
      },
    },
  ],
}, 'confirm_cards_effect.js');
